import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/Shield';
import { useCountdown } from './useCountdown';
export function FinalCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 md:py-12 px-4 bg-brand-dark text-white" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <div className="text-center mb-8" data-id="element-91">
          <h2 className="font-heading text-2xl md:text-3xl font-bold mb-4 text-brand-cream" data-id="element-92">
            ⚖️ ¿CUÁNTO CUESTA NO EMPEZAR?
          </h2>
          <div className="space-y-1.5 text-base text-gray-300 mb-5" data-id="element-93">
            <p data-id="element-94">Seguir postergando una habilidad hermosa.</p>
            <p data-id="element-95">Seguir consumiendo tutoriales sin avanzar.</p>
            <p data-id="element-96">Seguir pensando que no sos capaz.</p>
            <p data-id="element-97">Seguir esperando el momento perfecto.</p>
          </div>
          <div className="text-lg md:text-xl font-bold text-brand-pink" data-id="element-98">
            <p className="mb-1" data-id="element-99">El mejor momento para empezar fue ayer.</p>
            <p data-id="element-100">El segundo mejor momento es hoy.</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-5 md:p-8 text-center text-brand-dark shadow-2xl relative overflow-hidden" data-id="element-101">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-pink" data-id="element-102"></div>

          <div className="mb-3" data-id="element-103">
            <p className="text-xs md:text-sm font-bold text-red-500 mb-1" data-id="element-104">
              ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
            </p>
            <div className="flex justify-center gap-2 font-mono text-base md:text-lg font-bold bg-red-50 text-red-600 py-1.5 rounded-lg w-fit mx-auto px-3" data-id="element-105">
              <span data-id="element-106">{hours} hs</span> : <span data-id="element-107">{minutes} min</span> :{' '}
              <span data-id="element-108">{seconds} seg</span>
            </div>
          </div>

          <h3 className="font-heading text-xl md:text-2xl font-black text-brand-dark mb-1" data-id="element-109">
            🎨 ARTE BORDADO™
          </h3>
          <p className="text-brand-purple font-bold mb-3 text-sm md:text-base" data-id="element-110">
            📘 Tomo 1 + 📙 Tomo 2 + 🎁 4 Bonos
          </p>

          <div className="mb-4" data-id="element-111">
            <p className="text-gray-400 line-through text-base font-medium mb-0" data-id="element-112">
              $49.999
            </p>
            <div className="flex items-start justify-center" data-id="element-113">
              <span className="text-xl font-bold mt-1" data-id="element-114">$</span>
              <span className="text-4xl md:text-5xl font-black tracking-tight" data-id="element-115">
                19.999
              </span>
              <span className="text-base font-bold mt-1 ml-1" data-id="element-116">ARS</span>
            </div>
          </div>

          <button onClick={scrollToPricing} className="w-full bg-brand-coral hover:bg-brand-coralHover text-white font-bold text-base md:text-lg py-4 px-6 rounded-xl shadow-glow transition-all transform hover:-translate-y-1 active:translate-y-0 mb-3" data-id="element-117">
            ➜ QUIERO APRENDER ARTE BORDADO HOY
          </button>

          <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 font-medium mb-2" data-id="element-118">
            <div className="flex items-center gap-1" data-id="element-119">
              <LockIcon fontSize="inherit" data-id="element-120" /> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-121">
              <span className="text-green-500 text-sm" data-id="element-122">⚡</span> Acceso
              inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-123">
              <ShieldIcon fontSize="inherit" data-id="element-124" /> Garantía 7 días
            </div>
          </div>

          <p className="text-xs font-bold text-red-500 uppercase tracking-wider" data-id="element-125">
            Cupos limitados
          </p>
        </div>
      </div>
    </section>;
}